import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import SalesPage from "@/pages/SalesPage";
import PropertyDetailPage from "@/pages/PropertyDetailPage";
import HonorairesPage from "@/pages/HonorairesPage";
import ContactPage from "@/pages/ContactPage";
import LegalPage from "@/pages/LegalPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Navigation />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/ventes" element={<SalesPage />} />
            <Route path="/bien/:reference" element={<PropertyDetailPage />} />
            <Route path="/honoraires" element={<HonorairesPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/mentions-legales" element={<LegalPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
        </main>
        <Footer />
        <Toaster position="bottom-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
